import { EvolucaoPlanoCiap, EvolucaoPlanoCid11 } from 'graphql/types.generated'
import {
  CODIGO_PROCEDIMENTO_SISAB,
  showCodigoProcedimento,
} from 'view/atendimentos/detail/soap/objetivo/resultados-exames/util-resultadosExames'

import { HistoricoPlanoIntervencaoItem, HistoricoPlanoTerminologia, labelTerminologia } from './model-historicoPlano'

const ordemTerminologia: Record<HistoricoPlanoTerminologia, number> = {
  CIAP2: 1,
  CID11: 2,
  PROCEDIMENTO: 3,
}

export const getLabelTerminologia = (terminologia: HistoricoPlanoTerminologia, codigo: string): string | undefined => {
  if (terminologia === 'PROCEDIMENTO' && codigo === CODIGO_PROCEDIMENTO_SISAB) {
    return undefined
  }

  return labelTerminologia[terminologia]
}

export const getHistoricoPlanoIntervencoesOrdenadas = (
  intervencoesProcedimentos?: ReadonlyArray<EvolucaoPlanoCiap> | null,
  cids11?: ReadonlyArray<EvolucaoPlanoCid11> | null
): HistoricoPlanoIntervencaoItem[] => {
  const itens = [...getItensIntervencoesProcedimentos(intervencoesProcedimentos), ...getItensCid11(cids11)]

  return sortItensPlano(itens)
}

const getItensIntervencoesProcedimentos = (
  intervencoesProcedimentos?: ReadonlyArray<EvolucaoPlanoCiap> | null
): HistoricoPlanoIntervencaoItem[] => {
  const itens: HistoricoPlanoIntervencaoItem[] = []

  intervencoesProcedimentos?.forEach(({ id, ciap, procedimento, nota }) => {
    if (ciap) {
      itens.push({
        id: `ciap-${id}`,
        descricao: ciap.descricao,
        codigo: ciap.codigo,
        terminologia: 'CIAP2',
        nota,
      })
    }

    if (procedimento) {
      itens.push({
        id: `procedimento-${id}`,
        descricao: procedimento.descricao,
        codigo: showCodigoProcedimento(procedimento.codigo),
        terminologia: 'PROCEDIMENTO',
        nota: ciap ? undefined : nota,
      })
    }
  })

  return itens
}

const getItensCid11 = (cids11?: ReadonlyArray<EvolucaoPlanoCid11> | null): HistoricoPlanoIntervencaoItem[] => {
  return (
    cids11?.map(
      ({ id, cid11, nota }): HistoricoPlanoIntervencaoItem => ({
        id: `cid11-${id}`,
        descricao: cid11.nome.toUpperCase(),
        codigo: cid11.codigo,
        terminologia: 'CID11',
        nota,
      })
    ) ?? []
  )
}

const sortItensPlano = (itens: HistoricoPlanoIntervencaoItem[]): HistoricoPlanoIntervencaoItem[] => {
  return itens.sort((a, b) => {
    const ordem = ordemTerminologia[a.terminologia] - ordemTerminologia[b.terminologia]

    return ordem !== 0 ? ordem : a.descricao.localeCompare(b.descricao)
  })
}
